
//male

import golfTrousers_M_img1 from "../assets/adidas/male/adidas-ultimate365-tapered-golf-trousers-grey/img_1.png"
import golfTrousers_M_img2 from "../assets/adidas/male/adidas-ultimate365-tapered-golf-trousers-grey/img_2.png"
import golfTrousers_M_img3 from "../assets/adidas/male/adidas-ultimate365-tapered-golf-trousers-grey/img_3.png"

import collegiateHoodie_M_img1 from "../assets/adidas/male/collegiate-hoodie-blue/img_1.png"
import collegiateHoodie_M_img2 from "../assets/adidas/male/collegiate-hoodie-blue/img_2.png"
import collegiateHoodie_M_img3 from "../assets/adidas/male/collegiate-hoodie-blue/img_3.png"

import repellentJacket_M_img1 from "../assets/adidas/male/premium-essentials-water-repellent-jacket/img_1.png"
import repellentJacket_M_img2 from "../assets/adidas/male/premium-essentials-water-repellent-jacket/img_2.png"
import repellentJacket_M_img3 from "../assets/adidas/male/premium-essentials-water-repellent-jacket/img_3.png"

import coachesJacket_M_img1 from "../assets/adidas/male/dugout-coaches-jacket/img_1.png"
import coachesJacket_M_img2 from "../assets/adidas/male/dugout-coaches-jacket/img_2.png"
import coachesJacket_M_img3 from "../assets/adidas/male/dugout-coaches-jacket/img_3.png"

import replicaSummerPack_M_img1 from "../assets/adidas/male/mercedes-amg-petronas-formula-one-team-driver-jersey-replica-summer-pack/img_1.png"
import replicaSummerPack_M_img2 from "../assets/adidas/male/mercedes-amg-petronas-formula-one-team-driver-jersey-replica-summer-pack/img_2.png"
import replicaSummerPack_M_img3 from "../assets/adidas/male/mercedes-amg-petronas-formula-one-team-driver-jersey-replica-summer-pack/img_3.png"

import myshelterDownParka_M_img1 from "../assets/adidas/male/myshelter-down-parka/img_1.png"
import myshelterDownParka_M_img2 from "../assets/adidas/male/myshelter-down-parka/img_2.png"
import myshelterDownParka_M_img3 from "../assets/adidas/male/myshelter-down-parka/img_3.png"

import basketballShorts_M_imag1 from "../assets/adidas/male/adidas-originals-basketball-shorts-beige/img_1.png"
import basketballShorts_M_imag2 from "../assets/adidas/male/adidas-originals-basketball-shorts-beige/img_2.png"
import basketballShorts_M_imag3 from "../assets/adidas/male/adidas-originals-basketball-shorts-beige/img_3.png"

import fauxLeatherWideJoggers_M_img1 from "../assets/adidas/male/adidas-x-jeremy-scott-faux-leather-wide-joggers/img_1.png"
import fauxLeatherWideJoggers_M_img2 from "../assets/adidas/male/adidas-x-jeremy-scott-faux-leather-wide-joggers/img_2.png"
import fauxLeatherWideJoggers_M_img3 from "../assets/adidas/male/adidas-x-jeremy-scott-faux-leather-wide-joggers/img_3.png"

// female

import tracksuitBottomsF_img1 from "../assets/adidas/female/adicolor-classic-firebird-loose-track-tracksuit-bottoms/img_1.png"
import tracksuitBottomsF_img2 from "../assets/adidas/female/adicolor-classic-firebird-loose-track-tracksuit-bottoms/img_2.png"
import tracksuitBottomsF_img3 from "../assets/adidas/female/adicolor-classic-firebird-loose-track-tracksuit-bottoms/img_3.png"

import tShirtGreen_F_img1 from "../assets/adidas/female/adidas-3-stripes-t-shirt-green/img_1.png"
import tShirtGreen_F_img2 from "../assets/adidas/female/adidas-3-stripes-t-shirt-green/img_2.png"
import tShirtGreen_F_img3 from "../assets/adidas/female/adidas-3-stripes-t-shirt-green/img_3.png"

// import basketballShorts_F_img1 from "../assets/adidas/female/adidas-originals-basketball-shorts-beige/img_1.png"
// import basketballShorts_F_img2 from "../assets/adidas/female/adidas-originals-basketball-shorts-beige/img_2.png"
// import basketballShorts_F_img3 from "../assets/adidas/female/adidas-originals-basketball-shorts-beige/img_3.png"

import summerGlowSkirt_F_img1 from  "../assets/adidas/female/adidas-originals-summer-glow-skirt/img_1.png"
import summerGlowSkirt_F_img2 from  "../assets/adidas/female/adidas-originals-summer-glow-skirt/img_2.png"
import summerGlowSkirt_F_img3 from  "../assets/adidas/female/adidas-originals-summer-glow-skirt/img_3.png"

import fashionTrackTop_F_img1 from "../assets/adidas/female/adidas-x-jeremy-scott-fashion-track-top/img_1.png"
import fashionTrackTop_F_img2 from "../assets/adidas/female/adidas-x-jeremy-scott-fashion-track-top/img_2.png"
import fashionTrackTop_F_img3 from "../assets/adidas/female/adidas-x-jeremy-scott-fashion-track-top/img_3.png"

import scottTracksuitBottoms_F_img1 from "../assets/adidas/female/adidas-x-jeremy-scott-fashion-track-tracksuit-bottoms/img_1.png"
import scottTracksuitBottoms_F_img2 from "../assets/adidas/female/adidas-x-jeremy-scott-fashion-track-tracksuit-bottoms/img_2.png"
import scottTracksuitBottoms_F_img3 from "../assets/adidas/female/adidas-x-jeremy-scott-fashion-track-tracksuit-bottoms/img_3.png"

import fauxLeatherDress_F_img1 from "../assets/adidas/female/adidas-x-jeremy-scott-faux-leather-dress/img_1.png"
import fauxLeatherDress_F_img2 from "../assets/adidas/female/adidas-x-jeremy-scott-faux-leather-dress/img_2.png"
import fauxLeatherDress_F_img3 from "../assets/adidas/female/adidas-x-jeremy-scott-faux-leather-dress/img_3.png"

import crewneckSweatshirt_F_img1 from "../assets/adidas/female/blocking-crewneck-sweatshirt/img_1.png"
import crewneckSweatshirt_F_img2 from "../assets/adidas/female/blocking-crewneck-sweatshirt/img_2.png"
import crewneckSweatshirt_F_img3 from "../assets/adidas/female/blocking-crewneck-sweatshirt/img_3.png"

import essentialsLeggings_F_img1 from "../assets/adidas/female/running-essentials-leggings/img_1.png"
import essentialsLeggings_F_img2 from "../assets/adidas/female/running-essentials-leggings/img_2.png"
import essentialsLeggings_F_img3 from "../assets/adidas/female/running-essentials-leggings/img_3.png"

import climacoolDress_F_img1 from "../assets/adidas/female/tennis-pro-climacool-dress/img_1.png"
import climacoolDress_F_img2 from "../assets/adidas/female/tennis-pro-climacool-dress/img_2.png"
import climacoolDress_F_img3 from "../assets/adidas/female/tennis-pro-climacool-dress/img_3.png"
import { HARDCODED_SCAN_ID_FEMALE, HARDCODED_SCAN_ID_MALE } from "./constant"

export const IMAGES_DATA = {
  // male: {
    "premium-essentials-water-repellent-jacket": {
      url: [repellentJacket_M_img1, repellentJacket_M_img2, repellentJacket_M_img3],
      scanId: HARDCODED_SCAN_ID_MALE
    },
    "collegiate-hoodie-blue": {
      url: [collegiateHoodie_M_img1, collegiateHoodie_M_img2, collegiateHoodie_M_img3],
      scanId: HARDCODED_SCAN_ID_MALE
    },
    "adidas-ultimate365-tapered-golf-trousers-grey": {
      url: [golfTrousers_M_img1, golfTrousers_M_img2, golfTrousers_M_img3],
      scanId: HARDCODED_SCAN_ID_MALE
    },
    "dugout-coaches-jacket": {
      url: [coachesJacket_M_img1, coachesJacket_M_img2, coachesJacket_M_img3],
      scanId: HARDCODED_SCAN_ID_MALE
    },
    "mercedes-amg-petronas-formula-one-team-driver-jersey-replica-summer-pack": {
      url: [replicaSummerPack_M_img1, replicaSummerPack_M_img2, replicaSummerPack_M_img3],
      scanId: HARDCODED_SCAN_ID_MALE
    },
    "myshelter-down-parka": {
      url: [myshelterDownParka_M_img1, myshelterDownParka_M_img2, myshelterDownParka_M_img3],
      scanId: HARDCODED_SCAN_ID_MALE
    },
    "adidas-originals-basketball-shorts-beige": {
      url: [basketballShorts_M_imag1, basketballShorts_M_imag2, basketballShorts_M_imag3],
      scanId: HARDCODED_SCAN_ID_MALE
    },
    "adidas-x-jeremy-scott-faux-leather-wide-joggers": {
      url: [fauxLeatherWideJoggers_M_img1, fauxLeatherWideJoggers_M_img2, fauxLeatherWideJoggers_M_img3],
      scanId: HARDCODED_SCAN_ID_MALE
    },
  // },
  // female: {
    "adicolor-classic-firebird-loose-track-tracksuit-bottoms": {
      url: [tracksuitBottomsF_img1, tracksuitBottomsF_img2, tracksuitBottomsF_img3],
      scanId: HARDCODED_SCAN_ID_FEMALE
    },
    "adidas-3-stripes-t-shirt-green": {
      url: [tShirtGreen_F_img1, tShirtGreen_F_img2, tShirtGreen_F_img3],
      scanId: HARDCODED_SCAN_ID_FEMALE
    },
    // "adidas-originals-basketball-shorts-beige": {
    //   url: [basketballShorts_F_img1, basketballShorts_F_img2, basketballShorts_F_img3],
    //   scanId: HARDCODED_SCAN_ID_FEMALE
    // },
    "adidas-originals-summer-glow-skirt": {
      url: [summerGlowSkirt_F_img1, summerGlowSkirt_F_img2, summerGlowSkirt_F_img3],
      scanId: HARDCODED_SCAN_ID_FEMALE
    },
    "adidas-x-jeremy-scott-fashion-track-top": {
      url: [fashionTrackTop_F_img1, fashionTrackTop_F_img2, fashionTrackTop_F_img3],
      scanId: HARDCODED_SCAN_ID_FEMALE
    },
    "adidas-x-jeremy-scott-fashion-track-tracksuit-bottoms": {
      url: [scottTracksuitBottoms_F_img1, scottTracksuitBottoms_F_img2, scottTracksuitBottoms_F_img3],
      scanId: HARDCODED_SCAN_ID_FEMALE
    },
    "adidas-x-jeremy-scott-faux-leather-dress": {
      url: [fauxLeatherDress_F_img1, fauxLeatherDress_F_img2, fauxLeatherDress_F_img3],
      scanId: HARDCODED_SCAN_ID_FEMALE
    },
    "blocking-crewneck-sweatshirt": {
      url: [crewneckSweatshirt_F_img1, crewneckSweatshirt_F_img2, crewneckSweatshirt_F_img3],
      scanId: HARDCODED_SCAN_ID_FEMALE
    },
    "running-essentials-leggings": {
      url: [essentialsLeggings_F_img1, essentialsLeggings_F_img2, essentialsLeggings_F_img3],
      scanId: HARDCODED_SCAN_ID_FEMALE
    },
    "tennis-pro-climacool-dress": {
      url: [climacoolDress_F_img1, climacoolDress_F_img2, climacoolDress_F_img3],
      scanId: HARDCODED_SCAN_ID_FEMALE
    }
  // }
}
